export const CHAT_PERSIST_KEY = 'sia.chat.persist.v1'

function safeJsonParse(value) {
  try {
    return JSON.parse(value)
  } catch {
    return null
  }
}

export function loadChatPersist() {
  if (typeof window === 'undefined') return null
  const raw = window.localStorage.getItem(CHAT_PERSIST_KEY)
  if (!raw) return null
  const parsed = safeJsonParse(raw)
  if (!parsed || typeof parsed !== 'object') return null
  return parsed
}

export function saveChatPersist(payload) {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(CHAT_PERSIST_KEY, JSON.stringify(payload))
  } catch {
    // Ignore storage failures (quota, private mode, etc).
  }
}
